// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"239bf626","732":"85c15874","977":"3b0009d1"}[chunkId] + ".chunk.js";
};